'use client';

import React from 'react';
import Image from 'next/image';
import styles from './PageSpinner.module.css';
import logoIcon from '@Assets/logo_icon.svg';

const LETTERS = ['W', 'I', 'Z', 'I', 'U', 'M'];

const PageSpinner: React.FC = () => {
    return (
        <div className={styles.overlay}>
            <div className={styles.container}>
                <Image
                    src={logoIcon}
                    alt='Wizium'
                    width={40}
                    height={40}
                    className={styles.logo}
                />
                <div className={styles.text}>
                    {LETTERS.map((letter, index) => (
                        <span
                            key={index}
                            className={styles.letter}
                        >
                            {letter}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PageSpinner;
